export default {
      id: "pay_norton-usage",
      viewBox: "0 0 83 35",
      url: __webpack_public_path__ + "sprite.svg#pay_norton",
      toString: function () {
        return this.url;
      }
    }